import _ from 'underscore';

export module Sanitizer {

  // clean up user provided text
  export function trimTextOrUndefined(description: string): string{
    if (!_.isString(description)){
        description = undefined;
    }
    else {
      description = description.trim();
      if (_.isEmpty(description)) {
        description = undefined;
      }
    }
    return description;
  }

}
